import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  isCompanyMatchingApiUrl,
  isCvthequeApiUrl,
  isDashboardApiUrl,
  isEntrepriseApiUrl,
  isEntretienApiUrl,
  isMatchingApiUrl,
  isOffreApiUrl,
  isPublicInvitationApiUrl,
} from '../../domain/api/cv-api.paths';
import { AuthService } from '../auth/auth.service';

function isPublicAuthRequest(url: string): boolean {
  return url.startsWith(environment.authUrl);
}

function isProtectedDataApi(url: string): boolean {
  if (
    isPublicAuthRequest(url) ||
    isCvthequeApiUrl(url) ||
    isEntrepriseApiUrl(url) ||
    isOffreApiUrl(url) ||
    isDashboardApiUrl(url) ||
    isEntretienApiUrl(url) ||
    isMatchingApiUrl(url) ||
    isPublicInvitationApiUrl(url)
  ) {
    return false;
  }
  return (
    url === environment.apiUrl || url.startsWith(`${environment.apiUrl}/`)
  );
}

export const adminApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isProtectedDataApi(req.url)) {
    return next(req);
  }

  const auth = inject(AuthService);
  if (auth.isAdmin()) {
    return next(req);
  }

  if (auth.isCompany() && isCompanyMatchingApiUrl(req.url)) {
    return next(req);
  }

  return throwError(
    () =>
      new HttpErrorResponse({
        status: 403,
        statusText: 'Forbidden',
        url: req.url,
      }),
  );
};
